<template>
  <v-row>
    <v-col cols="1">
      <v-select
        v-on:change="selectedPage = 1;"
        :items="[10, 20, 50, 100]"
        v-model="selectedSize"
        label="Rows per page"
      ></v-select>
    </v-col>
    <v-spacer></v-spacer>
    <v-col>
      <v-pagination
        v-if="totalCount"
        v-model="selectedPage"
        total-visible="10"
        :length="totalCount < size ? 1 : Math.ceil(totalCount / size)"
      ></v-pagination>
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="2">
      <span v-if="totalCount">
        {{(page - 1) * size + 1}} -
        {{
          Math.min(
            page * size,
            totalCount
          )
        }}
        of {{ totalCount }}
      </span>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "PaginationSelect",
  props: {
    totalCount: Number,
    size: Number,
    page: Number,
  },
  data: function () {
    return {
      selectedPage: this.page ?? 1,
      selectedSize: this.size ?? 20,
    };
  },
  methods: {
    load() {
      this.$emit('load');
    },
  },
  watch: {
    selectedPage(newValue: Number, oldValue: Number) {
      if (!!newValue && newValue != this.page)
      {
        this.$emit('changePage', this.selectedPage);
        this.load();
      }
    },
    selectedSize(newValue: Number, oldValue: Number) {
      if (!!newValue && newValue != this.size) this.$emit('changeSize', this.selectedSize);
    },
    page(newValue: number) {
      if (!!newValue && newValue != this.selectedPage) this.selectedPage = newValue;
    },
    size(newValue: number) {
      if (!!newValue && newValue != this.selectedSize) this.selectedSize = newValue;
    },
  }
});
</script>